export default __webpack_public_path__ + "static/media/logo-mx-movies.a2907753.jpg";